import { updatesData } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-flashlight-line mr-1"></i>实时追踪
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            热点事件实时更新，最新鲜的爆料第一时间掌握
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-background-300/60"></div>

          <div className="space-y-0">
            {updatesData.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pb-5 last:pb-0 pl-10 md:pl-14 group">
                <div
                  className={`absolute left-[13px] md:left-[21px] top-1.5 w-2.5 h-2.5 md:w-3 md:h-3 rounded-full border-2 ${
                    item.hot
                      ? 'bg-primary-500 border-primary-300'
                      : 'bg-background-300 border-background-200'
                  } z-10`}
                ></div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span
                      className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                        item.hot
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                    {item.hot && (
                      <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
                    )}
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed font-medium group-hover:text-primary-600 transition-colors cursor-pointer">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}